




















import Vue, { PropOptions } from 'vue';
import BillingService, { BillingAccount, Purchase } from '~/services/BillingService';
import BaseCard from '../components/BaseCard.vue';
import Table, { TableHeader } from '../components/Table.vue';
import { format } from '~/utils/date-fns';

interface TableItem {
    key: number;
    cells: string[];
}

export default Vue.extend({
    name: 'Purchases',
    components: {
        BaseCard,
        Table,
    },
    props: {
        billingAccount: {
            type: Object,
            required: true,
        } as PropOptions<BillingAccount>,
    },
    data() {
        return {
            service: new BillingService(),
            loading: false,
            error: null as string | null,

            purchases: [] as Purchase[],
        };
    },
    computed: {
        headers(): TableHeader[] {
            return ['product', 'date', 'price'].map<TableHeader>(col => ({
                label: this.$t(`plansAndBilling.purchases.headers.${col}`).toString(),
            }));
        },
        items(): TableItem[] {
            return this.purchases.map(purchase => {
                const locale = window.navigator.languages[0] || window.navigator.language;
                const price = `${(purchase.price / 100).toLocaleString(locale, {
                    style: 'currency',
                    currency: purchase.currency,
                })}`;

                return {
                    key: purchase.purchasedAt.getTime(),
                    cells: [purchase.productName, format(purchase.purchasedAt, 'Pp'), price],
                };
            });
        },
        empty(): string | null {
            if (this.loading || !!this.error) return null;
            return !this.purchases.length
                ? this.$t('plansAndBilling.purchases.noPurchases').toString()
                : null;
        },
    },
    methods: {
        getPurchases() {
            this.loading = true;
            this.service
                .getPurchases(this.billingAccount.id)
                .then(purchases => (this.purchases = purchases))
                .catch(this.handleError)
                .finally(() => (this.loading = false));
        },

        handleError(err: any) {
            console.error(err);
            this.error = this.$t('errors.tryAgain').toString();
            return null;
        },
    },
    mounted() {
        this.getPurchases();
    },
});
